$(document).ready(function(){

    var swiper = new Swiper(".cart-customer-reviews.swiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      mousewheel: true,
      keyboard: true,
    });

    var swiper = new Swiper(".custom-icon-text-left .swiper", {
      slidesPerView: 6,
      mousewheel: true,
      keyboard: true,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
        },
        480: {
          slidesPerView: 2,
        },
        640: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
        1100: {
          slidesPerView: 6,
        }
     },
    });

    var varint = $('.buy_cust').prev('.shopify-app-block');
    $('.buy_cust').before('<div class="dynmic_variants"></div>');
    $('.dynmic_variants').html(varint);


  var indexValue = 0;

$(document).on('click', '.dpo_swatch img', function() {
    var $parentSwatch = $(this).parents('.dpo_swatch');
      if ($parentSwatch.hasClass('select-wp')) {
          $parentSwatch.removeClass('select-wp');
          indexValue--;
      } else {
          $parentSwatch.addClass('select-wp');
          indexValue++;
      }
  
    setTimeout(function(){
      if(indexValue >= 5){
        $('.dpo_swatch').addClass('click-disable');
      }
      else{
        $('.dpo_swatch').removeClass('click-disable');
      }
    },300)
    
});


  $(document).on('click','.collection-filter .filter-form',function(e){
    e.preventDefault();
    // $('.collection-filter .collapsible-content--sidebar').toggleClass('is-open')
  });

$(document).on('click','.collapsible-content__inner ul li',function(){
  console.log("runnnunununununu")
  // $(this).find('.tag__input').prop('checked', true)
})

  
});